export const sendLoginMail = async (email, fin, kmStand, api) => {
  try {
    const response = await fetch(`${api}/login/send-login-link`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, fin, kmStand }),
    });

    if (response.ok) {
      return true; // Return the resolved data
    } else {
      console.error("Failed to fetch data for email:", email);
      return false;
    }
  } catch (error) {
    console.error("Error fetching data for email:", email, error);
    return null;
  }
};
